'use client';
import Link from 'next/link';
import { FaSignInAlt } from 'react-icons/fa';

import { useAuth } from '@/lib/auth-hooks';

export function FooterAuthLinks() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { isSignedIn } = useAuth();

  if (isSignedIn) return null;

  return (
    <>
      <li>
        <Link
          href="/sign-in"
          className="group inline-flex items-center gap-2 text-gray-300 hover:text-primary-500 hover:no-underline">
          <FaSignInAlt className="text-gray-500 group-hover:text-primary-500" />
          Sign In
        </Link>
      </li>
    </>
  );
}
